import {
   View,
   Text,
   Image,
   StyleSheet,
   ImageBackground,
   Dimensions,
   FlatList,
   ScrollView,
} from 'react-native';
import React, {useState, useEffect} from 'react';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
const {width, height} = Dimensions.get('window');
import UISvg from '../../components/svg';
import {
   drawerListBackgroundColor,
   FONT_FAMILY_REGULAR,
   isMacOS,
   isMobile,
   isWeb,
   isWindows,
} from '../../utils/utils';
import {GET_ADVERSTISEMENT} from '../../utils/utils';
import logger from '../../utils/logger';
import {apiGetRequest} from '../../service/network_access';
import {useNavigation} from '@react-navigation/native';
import {AdevertisementItem} from '../dashboard/AdvertisementItem';
import {Platform} from 'react-native';

const CourseDescriptionHeader = props => {
   const {image, courseName, moduleLevel, hourLevel} = props;
   const isLandscapemode = useSelector(selectScreenOrientation);

   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const isMobilePlatform = isIOS || isAndroid;
   const [advertisementList, setAdvertisementList] = useState([]);
   const navigation = useNavigation();
   // const imgWidth = width > height ? width : height;
   // const posterWidth = isWeb ? window.innerWidth * 0.29 : imgWidth * 0.36;
   const [posterHeight, setPosterHeight] = useState(0);

   const [posterWidth, setPosterWidth] = useState([]);
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const windowHeight = window.innerHeight ?? Dimensions.get('window').height;
   useEffect(() => {
      const deviceHeightForWeb =
         windowHeight < 780
            ? // Medium size Desktop/Tablet
              windowHeight < 680
               ? windowHeight < 600
                  ? windowHeight * 0.27
                  : windowHeight * 0.325
               : windowHeight < 701
               ? windowHeight * 0.35
               : windowHeight < 750
               ? windowHeight * 0.415
               : windowHeight * 0.367
            : // Large size Desktop
            windowHeight > 1000
            ? windowHeight * 0.5
            : windowHeight * 0.45;
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      const {width, height} = windowDimensions;
      const imgWidth = width > height ? width : height;
      setPosterWidth(isWeb ? window.innerWidth * 0.29 : imgWidth * 0.4);
      setPosterHeight(width * 0.54);
      Dimensions.addEventListener('change', handleResize);
      return () => {
         Dimensions.removeEventListener('change', handleResize);
      };
   }, [windowDimensions]);

   function getAdvertisementDataFromAPI() {
      apiGetRequest({url: GET_ADVERSTISEMENT})
         .then(res => {
            const advertisements = res.AdvertisementRecordsList;
            logger('advertisements:' + JSON.stringify(res));
            advertisements.length > 0
               ? setAdvertisementList(advertisements)
               : setAdvertisementList(placeHolderData);
         })
         .catch(error => {
            logger('error::', error);
         });
   }

   const render = ({item}) => {
      return (
         <AdevertisementItem
            item={item}
            navigation={navigation}
            posterWidth={posterWidth}
         />
      );
   };

   useEffect(() => {
      (async () => {
         getAdvertisementDataFromAPI();
      })();
      return () => {};
   }, []);

   return (
      <View
         style={{
            flex: isLandscapemode ? 0.6 : null,
            backgroundColor: isLandscapemode ? 'white' : '#001231',
            ...Platform.select({
               web: {
                  flex: null,
                  width: isLandscapemode ? '29vw' : null,
               },
            }),
         }}>
         {!isLandscapemode && props.isModuleCountHoursVisible ? (
            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  height: 30,
               }}>
               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/course_hightlight_24.png')}
                     style={{
                        width: 10,
                        height: 10,
                        resizeMode: 'contain',
                     }}
                  />
                  <Text
                     style={{
                        fontSize: 8,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_REGULAR,
                        fontStyle: 'normal',
                        color: 'white',
                        marginLeft: 5,
                        marginRight: 8,
                     }}>
                     {moduleLevel}
                  </Text>
               </View>

               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/Timer.png')}
                     style={{
                        width: 10,
                        height: 10,
                        resizeMode: 'contain',
                     }}
                  />
                  <Text
                     style={{
                        fontSize: 8,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_REGULAR,
                        color: 'white',
                        marginLeft: 5,
                        marginRight: 8,
                     }}>
                     {hourLevel}
                  </Text>
               </View>
            </View>
         ) : null}
         {!isLandscapemode && !props.isModuleCountHoursVisible ? (
            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  height: 30,
               }}>
               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Text
                     style={{
                        fontSize: 8,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_REGULAR,
                        fontStyle: 'normal',
                        color: 'white',
                        marginLeft: 5,
                        marginRight: 8,
                     }}>
                     {'Practical Training'}
                  </Text>
               </View>
            </View>
         ) : null}
         <ImageBackground
            style={
               isLandscapemode
                  ? [
                       styles.imageLandScapeContainer,
                       {
                          //   height: !isMobilePlatform
                          //      ? height * 0.29
                          //      : height * 0.3,
                       },
                    ]
                  : [styles.imagePortraitContainer, {height: posterHeight}]
            }
            imageStyle={{
               resizeMode: 'cover',
            }}
            source={image}>
            {!isLandscapemode ? (
               <View style={styles.textContainerStyle}>
                  <UISvg
                     height="100%"
                     width="100%"
                     x1="50%"
                     y1="0%"
                     x2="50%"
                     y2="100%"
                     offset={['0%', '100%']}
                     stopColor={[
                        drawerListBackgroundColor,
                        drawerListBackgroundColor,
                     ]}
                     stopOpacity={['0', '1']}
                  />
                  <Text style={styles.textStyle}>{courseName}</Text>
               </View>
            ) : null}
         </ImageBackground>
         {isLandscapemode ? (
            <View
               style={{
                  backgroundColor: '#F0F3F9',
                  flex: 1,
                  marginTop: 5,
                  flexDirection: 'column',
                  marginBottom: !isWindows ? (!isMobile ? 10 : null) : null,
                  ...Platform.select({
                     web: {
                        marginBottom: null,
                     },
                     macos: {
                        marginBottom: null,
                     },
                  }),
                  //marginRight: 10,
               }}>
               <FlatList
                  data={advertisementList}
                  renderItem={render}
                  keyExtractor={item => item.Image}
                  numColumns={1}
                  contentContainerStyle={styles.contentContainer}
               />
            </View>
         ) : null}
      </View>
   );
};
const styles = StyleSheet.create({
   imagePortraitContainer: {
      // flex: 1,
      width: '100%',
      // height: width * 0.56,
      resizeMode: 'contain',
   },
   imageLandScapeContainer: {
      flex: 0.6,
      width: '100%',
      // height: Platform.OS === 'web' ? width * 0.29 * 0.56 : width * 0.4 * 0.56,
      resizeMode: 'contain',
   },
   textContainerStyle: {
      position: 'absolute',
      justifyContent: 'center',
      minHeight: 85,
      bottom: 0,
      width: '100%',
   },
   textStyle: {
      fontSize: 18,
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      fontWeight: '700',
      fontStyle: 'normal',
      marginLeft: 20,
      marginRight: 16,
      alignItems: 'center',
   },
   container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#F5FCFF',
   },
   contentContainer: {
      paddingVertical: 0,
   },
   itemContainer: {
      flex: 1,
      margin: 5,
      alignItems: 'center',
   },
   posterImage: {
      width: '100%',
      height: 200,
      resizeMode: 'cover',
   },
});
export default CourseDescriptionHeader;
